export interface AlertMessage {
  msg: string;
  alertType: string;
  id: string;
}

interface SetAlertAction {
  type: AlertActionTypes.SET_ALERT;
  payload: AlertMessage;
}

interface RemoveAlertAction {
  type: AlertActionTypes.REMOVE_ALERT;
  payload: string;
}

export enum AlertActionTypes {
  SET_ALERT = 'SET_ALERT',
  REMOVE_ALERT = 'REMOVE_ALERT',
}

export type AlertAction = SetAlertAction | RemoveAlertAction;
